module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "repost-banner"
  }, [_c('div', {
    staticClass: "dflex gap-25 align-center justify-space-between"
  }, [_c('div', {
    staticClass: "repost-content"
  }, [_c('div', {
    staticClass: "dflex align-center mb-4"
  }, [_c('img', {
    attrs: {
      "src": _vm.Icon,
      "width": "25",
      "height": "25"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "repost-head"
  }, [_vm._v(_vm._s(_vm.MainHeading) + " ")])]), _vm._v(" "), _c('p', {
    staticClass: "repost-text"
  }, [_vm._v(_vm._s(_vm.MainText))])]), _vm._v(" "), _c('div', {
    staticClass: "repost-img"
  }, [_c('img', {
    attrs: {
      "src": _vm.MainImage,
      "width": "100%"
    }
  })])]), _vm._v(" "), _c('router-link', {
    staticClass: "repost-banner-back",
    attrs: {
      "to": "/upload"
    }
  }, [_vm._v("\n            < Back\n        ")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-be2e5dca","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/BannerUpload/index.vue
// module id = 1845
// module chunks = 180